import React, { useEffect, useState } from "react";

import { useSearchParams, useNavigate } from "react-router-dom";

import { supabase } from "../lib/supabase";

import {

  CardElement,

  Elements,

  useStripe,

  useElements,

} from "@stripe/react-stripe-js";

import { loadStripe } from "@stripe/stripe-js";

const stripePromise = loadStripe(import.meta.env.VITE_STRIPE_PUBLIC_KEY);

function CheckoutForm() {

  const stripe = useStripe();

  const elements = useElements();

  const navigate = useNavigate();

  const [searchParams] = useSearchParams();

  const invoiceId = searchParams.get("invoice");

  const [invoice, setInvoice] = useState(null);

  const [loading, setLoading] = useState(false);

  // Local state for step management and billing details

  const [step, setStep] = useState(1);

  const [promoCode, setPromoCode] = useState("");

  const [billing, setBilling] = useState({

    fullName: "",

    emailAddress: "",

    phoneNumber: "",

    country: "India",

    address: "",

    city: "",

    state: "",

    pinCode: "",

  });

  useEffect(() => {
    loadInvoice();
    loadProfile();
  }, []);

  useEffect(() => {

    if (invoice && !billing.emailAddress) {

      setBilling((prev) => ({

        ...prev,

        emailAddress: invoice.user_email || "",

      }));

    }

  }, [invoice]);

  const loadInvoice = async () => {

    const { data, error } = await supabase

      .from("invoices")

      .select("*")

      .eq("id", invoiceId)

      .single();

    if (error) {

      console.error(error);

      return;

    }

    setInvoice(data);

  };

  const handlePayment = async () => {

    setLoading(true);

    try {

      const { data, error } = await supabase.functions.invoke(

        "create-payment-intent",

        { body: { invoice_id: invoice.id } }

      );

      if (error) throw error;

      if (!stripe || !elements) return;

      const result = await stripe.confirmCardPayment(data.client_secret, {

        payment_method: {

          card: elements.getElement(CardElement),

          billing_details: {

            name: billing.fullName,

            email: billing.emailAddress || invoice.user_email,

            phone: billing.phoneNumber,

            address: {

              line1: billing.address,

              city: billing.city,

              state: billing.state,

              postal_code: billing.pinCode,

              country: billing.country === "India" ? "IN" : undefined,

            }

          },

        },

      });

      if (result.error) throw new Error(result.error.message);

      if (result.paymentIntent.status === "succeeded") {

        const { data: updatedInvoice, error: updateError } = await supabase

          .from("invoices")

          .update({ status: "paid" })

          .eq("id", invoice.id)

          .select()

          .single();

        if (updateError) throw updateError;

        navigate(`/order-confirmation?invoice=${invoice.id}`, {

          state: { orderConfirmation: updatedInvoice },

          replace: true,

        });

      }

    } catch (err) {

      console.error(err);

      alert(err.message);

    } finally {

      setLoading(false);

    }

  };

  const handleProceedToPayment = async () => {

    if (
      !billing.fullName.trim() ||
      !billing.emailAddress.trim() ||
      !billing.phoneNumber.trim()
    ) {
      alert("Please fill Name, Email and Phone Number");
      return;
    }

    try {

      const {
        data: { user }
      } = await supabase.auth.getUser();

      if (!user) {
        alert("Please login first");
        return;
      }

      const profilePayload = {
        id: user.id,
        full_name: billing.fullName,
        email: billing.emailAddress,
        phone_number: Number(
          billing.phoneNumber.replace(/\D/g, "")
        ),
        role: "user"
      };

      const { error } = await supabase
        .from("profiles")
        .upsert(
          profilePayload,
          {
            onConflict: "id"
          }
        );

      if (error) {
        throw error;
      }

      setStep(2);

    } catch (err) {

      console.error(err);

      alert(
        err.message ||
        "Unable to save profile"
      );
    }
    await supabase
      .from("invoices")
      .update({
        user_email: billing.emailAddress
      })
      .eq("id", invoice.id);
  };

  const loadProfile = async () => {

    const {
      data: { user }
    } = await supabase.auth.getUser();

    if (!user) return;

    const { data } = await supabase
      .from("profiles")
      .select("*")
      .eq("id", user.id)
      .single();

    if (!data) return;

    setBilling(prev => ({
      ...prev,
      fullName: data.full_name || "",
      emailAddress: data.email || "",
      phoneNumber: data.phone_number
        ? String(data.phone_number)
        : ""
    }));
  };

  if (!invoice)

    return (
      <div className="flex justify-center items-center h-screen text-gray-500 font-medium animate-pulse">

        Loading invoice details...
      </div>

    );

  const displayCurrencySymbol = invoice.currency?.toUpperCase() === "USD" ? "$" : invoice.currency?.toUpperCase() + " ";

  return (
    <div className="min-h-screen bg-[#f8fafc] py-8 px-4 sm:px-6 lg:px-8 font-sans">
      <div className="max-w-6xl mx-auto">

        {/* Navigation Header */}
        <div className="mb-6">
          <button

            onClick={() => navigate(-1)}

            className="text-gray-600 hover:text-gray-900 flex items-center gap-2 text-sm font-semibold transition-all"
          >
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M10 19l-7-7m0 0l7-7m-7 7h18" />
            </svg>

            Back to Dashboard
          </button>
        </div>

        {/* Top Banner Card */}
        <div className="bg-[#13375c] text-white p-6 sm:p-8 rounded-2xl flex flex-col md:flex-row justify-between items-start md:items-center gap-6 shadow-md mb-8">
          <div>
            <div className="flex flex-wrap items-center gap-2 mb-3">
              <span className="bg-[#e5c158] text-[#13375c] text-xs font-bold px-3 py-1 rounded-full uppercase tracking-wider">

                {invoice.invoice_number || "INV-2026-2487"}
              </span>
              <span className="bg-[#244b7a] text-blue-200 text-xs px-3 py-1 rounded-full font-medium">

                Payment for Requested Service
              </span>
            </div>
            <h1 className="text-2xl sm:text-3xl font-bold tracking-tight">Official Admin Invoice Payment</h1>
            <p className="text-blue-200/80 text-sm mt-1">Raised by platform administration for your requested service settlement</p>
          </div>
          <div className="bg-[#19406b] border border-[#245285] rounded-xl px-8 py-4 min-w-[180px] text-center md:text-right shadow-inner">
            <span className="text-[10px] font-semibold text-blue-200 uppercase tracking-wider block mb-1">PAYABLE NET DUE</span>
            <span className="text-3xl font-extrabold text-[#e5c158]">{displayCurrencySymbol}{invoice.amount}</span>
          </div>
        </div>

        {/* Stepper Progress Bar */}
        <div className="flex justify-center items-center mb-10 max-w-md mx-auto relative">
          <div className="flex items-center gap-3">
            <div className="flex flex-col items-center">
              <div className="w-8 h-8 rounded-full flex items-center justify-center font-bold text-sm bg-[#13375c] text-white">

                {step > 1 ? (
                  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M5 13l4 4L19 7" />
                  </svg>

                ) : "1"}
              </div>
              <span className="text-xs font-bold text-[#13375c] mt-2 whitespace-nowrap">1. Billing Info</span>
            </div>
            <div className="w-12 sm:w-24 h-0.5 bg-gray-200 relative -top-3">
              <div className={`h-full bg-[#13375c] transition-all duration-300 ${step > 1 ? 'w-full' : 'w-0'}`} />
            </div>

            <div className="flex flex-col items-center">
              <div className={`w-8 h-8 rounded-full flex items-center justify-center font-bold text-sm ${step === 2 ? 'bg-[#13375c] text-white' : 'bg-gray-200 text-gray-500'}`}>

                2
              </div>
              <span className={`text-xs font-bold mt-2 whitespace-nowrap ${step === 2 ? 'text-[#13375c]' : 'text-gray-400'}`}>2. Payment</span>
            </div>
          </div>
        </div>

        {/* Two Column Layout */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 items-start">

          {/* Main Panel Column */}
          <div className="lg:col-span-2 bg-white rounded-2xl shadow-sm border border-gray-100 p-6 sm:p-8 min-h-[500px] flex flex-col justify-between">

            {step === 1 ? (

              /* STEP 1: Billing Information Form */
              <div>
                <h2 className="text-xl font-bold text-gray-800 mb-6">Billing Information</h2>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
                  <div>
                    <label className="block text-xs font-bold text-gray-700 mb-2">Full Name *</label>
                    <input

                      type="text"

                      value={billing.fullName}

                      onChange={e => setBilling({ ...billing, fullName: e.target.value })}

                      className="w-full px-4 py-2.5 rounded-lg border border-gray-300 focus:ring-1 focus:ring-[#13375c] focus:border-[#13375c] outline-none transition-all text-sm"

                      placeholder="John Doe"

                    />
                  </div>
                  <div>
                    <label className="block text-xs font-bold text-gray-700 mb-2">Email Address *</label>
                    <input

                      type="email"

                      value={billing.emailAddress}

                      onChange={e => setBilling({ ...billing, emailAddress: e.target.value })}

                      className="w-full px-4 py-2.5 rounded-lg border border-gray-300 focus:ring-1 focus:ring-[#13375c] focus:border-[#13375c] outline-none transition-all text-sm"

                      placeholder="john@example.com"

                    />
                  </div>
                  <div>
                    <label className="block text-xs font-bold text-gray-700 mb-2">Phone Number *</label>
                    <input

                      type="text"

                      value={billing.phoneNumber}

                      onChange={e => setBilling({ ...billing, phoneNumber: e.target.value })}

                      className="w-full px-4 py-2.5 rounded-lg border border-gray-300 focus:ring-1 focus:ring-[#13375c] focus:border-[#13375c] outline-none transition-all text-sm"

                      placeholder="+91 98765 43210"

                    />
                  </div>
                  <div>
                    <label className="block text-xs font-bold text-gray-700 mb-2">Country</label>
                    <select

                      value={billing.country}

                      onChange={e => setBilling({ ...billing, country: e.target.value })}

                      className="w-full px-4 py-2.5 rounded-lg border border-gray-300 focus:ring-1 focus:ring-[#13375c] focus:border-[#13375c] outline-none transition-all text-sm bg-white"
                    >
                      <option value="India">India</option>
                      <option value="United States">United States</option>
                      <option value="United Kingdom">United Kingdom</option>
                      <option value="Canada">Canada</option>
                      <option value="Australia">Australia</option>
                    </select>
                  </div>
                  <div className="sm:col-span-2">
                    <label className="block text-xs font-bold text-gray-700 mb-2">Address *</label>
                    <textarea

                      rows={3}

                      value={billing.address}

                      onChange={e => setBilling({ ...billing, address: e.target.value })}

                      className="w-full px-4 py-2.5 rounded-lg border border-gray-300 focus:ring-1 focus:ring-[#13375c] focus:border-[#13375c] outline-none transition-all text-sm resize-none"

                      placeholder="Street Address, Apartment, Suite, etc."

                    />
                  </div>
                  <div>
                    <label className="block text-xs font-bold text-gray-700 mb-2">City</label>
                    <input

                      type="text"

                      value={billing.city}

                      onChange={e => setBilling({ ...billing, city: e.target.value })}

                      className="w-full px-4 py-2.5 rounded-lg border border-gray-300 focus:ring-1 focus:ring-[#13375c] focus:border-[#13375c] outline-none transition-all text-sm"

                      placeholder="City Name"

                    />
                  </div>
                  <div className="grid grid-cols-2 gap-4">
                    <div>
                      <label className="block text-xs font-bold text-gray-700 mb-2">State</label>
                      <input

                        type="text"

                        value={billing.state}

                        onChange={e => setBilling({ ...billing, state: e.target.value })}

                        className="w-full px-4 py-2.5 rounded-lg border border-gray-300 focus:ring-1 focus:ring-[#13375c] focus:border-[#13375c] outline-none transition-all text-sm"

                        placeholder="State"

                      />
                    </div>
                    <div>
                      <label className="block text-xs font-bold text-gray-700 mb-2">PIN Code</label>
                      <input

                        type="text"

                        value={billing.pinCode}

                        onChange={e => setBilling({ ...billing, pinCode: e.target.value })}

                        className="w-full px-4 py-2.5 rounded-lg border border-gray-300 focus:ring-1 focus:ring-[#13375c] focus:border-[#13375c] outline-none transition-all text-sm"

                        placeholder="PIN Code"

                      />
                    </div>
                  </div>
                </div>
              </div>

            ) : (

              /* STEP 2: Payment Method Form */
              <div>
                <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-2 mb-6">
                  <h2 className="text-xl font-bold text-gray-800">End Payment Method</h2>
                  <span className="bg-[#e0e7ff] text-[#4f46e5] text-xs font-semibold px-3 py-1 rounded-full border border-indigo-200 flex items-center gap-1.5">
                    <span className="w-1.5 h-1.5 bg-[#4f46e5] rounded-full" />

                    Stripe Secure Gateway
                  </span>
                </div>

                {/* Select Gateway Section with UPI and Net Banking Hidden */}
                <div className="mb-6">
                  <label className="block text-xs font-bold text-gray-500 uppercase tracking-wider mb-3">Select Gateway Method</label>
                  <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
                    <div className="border-2 border-indigo-600 bg-indigo-50/10 rounded-xl p-4 flex flex-col items-center justify-center gap-2 cursor-pointer transition-all shadow-sm">
                      <svg className="w-6 h-6 text-[#13375c]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z" />
                      </svg>
                      <span className="text-xs font-bold text-[#13375c] text-center">Stripe Pay (Credit/Debit)</span>
                    </div>
                  </div>
                </div>

                {/* Stripe Elements Input Card Container */}
                <div className="mb-6">
                  <label className="block text-xs font-bold text-gray-500 uppercase tracking-wider mb-2">Card Information</label>
                  <div className="p-4 border border-gray-300 rounded-xl bg-white shadow-sm focus-within:ring-1 focus-within:ring-indigo-500 focus-within:border-indigo-500 transition-all">
                    <CardElement

                      options={{

                        style: {

                          base: {

                            fontSize: '15px',

                            color: '#1e293b',

                            fontFamily: 'system-ui, sans-serif',

                            '::placeholder': { color: '#94a3b8' }

                          }

                        }

                      }}

                    />
                  </div>
                </div>

                {/* End-to-End Encryption Banner */}
                <div className="bg-[#0f172a] text-white p-4 rounded-xl flex items-start gap-3.5 mb-6">
                  <div className="bg-amber-500/10 p-2.5 rounded-lg border border-amber-500/20 text-[#e5c158] mt-0.5">
                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
                    </svg>
                  </div>
                  <div>
                    <h4 className="text-xs font-bold text-gray-100">Stripe End-to-End Encryption</h4>
                    <p className="text-[11px] text-gray-400 mt-1 leading-relaxed">

                      Transactions are processed end-to-end via Stripe PCI-DSS Level 1 compliant infrastructure.
                    </p>
                  </div>
                </div>
              </div>

            )}

            {/* Form Footer Action Buttons */}
            <div className="flex justify-between items-center pt-6 border-t border-gray-100 mt-8">

              {step === 1 ? (
                <>
                  <button

                    disabled

                    className="px-6 py-2.5 rounded-lg border border-gray-200 text-gray-400 font-bold text-xs uppercase tracking-wider cursor-not-allowed"
                  >

                    Previous
                  </button>
                  <button

                    onClick={handleProceedToPayment}

                    className="bg-[#828f9d] hover:bg-[#717e8c] text-white px-6 py-2.5 rounded-lg font-bold text-xs uppercase tracking-wider transition-all"
                  >

                    Proceed to Payment
                  </button>
                </>

              ) : (
                <>
                  <button

                    onClick={() => setStep(1)}

                    className="px-6 py-2.5 rounded-lg border border-gray-300 text-gray-600 font-bold text-xs uppercase tracking-wider hover:bg-gray-50 transition-all"
                  >

                    Previous
                  </button>
                  <button

                    onClick={handlePayment}

                    disabled={loading || !stripe}

                    className={`px-8 py-3 rounded-xl font-bold text-sm text-white transition-all transform active:scale-[0.98] flex items-center gap-2 ${loading

                      ? "bg-gray-400 cursor-not-allowed"

                      : "bg-[#0f8a7a] hover:bg-[#0c7466] shadow-md shadow-emerald-100"

                      }`}
                  >
                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
                    </svg>

                    {loading ? "Processing..." : `Pay ${displayCurrencySymbol}${invoice.amount} Now`}
                  </button>
                </>

              )}
            </div>
          </div>

          {/* Right Column (Sidebar Items) */}
          <div className="space-y-6">

            {/* Invoice Summary Card */}
            <div className="bg-white rounded-2xl border border-gray-100 p-6 shadow-sm">
              <h3 className="text-base font-bold text-[#13375c] mb-4">Invoice Summary</h3>
              <div className="flex items-start gap-3 bg-gray-50 p-3.5 rounded-xl border border-gray-100 mb-4">
                <div className="bg-[#eff6ff] p-2.5 rounded-lg text-[#1e4875] border border-[#dbeafe]">
                  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                  </svg>
                </div>
                <div>
                  <h4 className="text-sm font-bold text-gray-800">Property Care Fee</h4>
                  <span className="text-[10px] font-bold text-amber-600 bg-amber-50 px-2 py-0.5 rounded border border-amber-100 inline-block mt-1">

                    Payment for Requested Service
                  </span>
                  <p className="text-[10px] text-gray-400 font-mono mt-1.5">{invoice.invoice_number || "INV-2026-2487"}</p>
                </div>
              </div>

              {/* Notes Area */}
              <div className="bg-[#fffbeb] border border-[#fde68a] rounded-xl p-4 mb-5">
                <span className="text-[10px] font-bold text-[#78350f] uppercase tracking-wider block mb-1">Admin Description / Notes:</span>
                <p className="text-xs text-[#78350f] font-medium leading-relaxed">{invoice.description || "Payment"}</p>
              </div>

              {/* Balance Summary */}
              <div className="space-y-3 pt-4 border-t border-gray-100">
                <div className="flex justify-between items-center text-xs text-gray-500">
                  <span>Invoice Amount</span>
                  <span className="font-semibold text-gray-800">{displayCurrencySymbol}{invoice.amount}</span>
                </div>
                <div className="flex justify-between items-center pt-3 border-t border-dashed border-gray-200">
                  <span className="text-sm font-bold text-[#13375c]">Payable Net Due</span>
                  <span className="text-lg font-extrabold text-[#13375c]">{displayCurrencySymbol}{invoice.amount}</span>
                </div>
              </div>
            </div>

            {/* Promo Code Card */}
            <div className="bg-white rounded-2xl border border-gray-100 p-6 shadow-sm">
              <h3 className="text-sm font-bold text-gray-800 mb-3">Promo Code</h3>
              <div className="flex gap-2 mb-3">
                <input

                  type="text"

                  value={promoCode}

                  onChange={e => setPromoCode(e.target.value)}

                  placeholder="Enter promo code"

                  className="flex-1 px-3 py-2 border border-gray-300 rounded-lg text-xs outline-none focus:ring-1 focus:ring-[#13375c] focus:border-[#13375c]"

                />
                <button className="bg-[#828f9d] hover:bg-[#717e8c] text-white px-4 py-2 rounded-lg font-bold text-xs uppercase transition-all">

                  Apply
                </button>
              </div>
              <p className="text-[10px] text-gray-400">

                Available codes: <span className="font-semibold text-gray-500">WELCOME10, FIRST500, NRI2024</span>
              </p>
            </div>

            {/* Secure Checkout Trust Banner */}
            <div className="bg-[#f0f6fa] border border-[#e2e8f0] rounded-2xl p-4 flex items-start gap-3">
              <div className="text-blue-600 mt-0.5">
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
                </svg>
              </div>
              <div>
                <h4 className="text-xs font-bold text-gray-800">Secure Checkout</h4>
                <p className="text-[10px] text-gray-500 mt-0.5 leading-relaxed">

                  Your information is protected with 256-bit SSL encryption
                </p>
              </div>
            </div>

          </div>

        </div>
      </div>
    </div>

  );

}

export default function Checkout() {

  return (
    <Elements stripe={stripePromise}>
      <CheckoutForm />
    </Elements>

  );

}
